import Compressor from 'compressorjs';
import dayjs from 'dayjs';

export const phoneRegex = /^\+?\d{1,15}$/;
export const phoneRegex10 = /^(02|03|05|07|08|09|01[2|6|8|9])\d{8}$/;
export const taxRegex = /^\d{10}(-\d{3})?$/;
export const cccdRegex = /([0-9]{12})\b/;

export const formatToCurrencyVND = (number) => {
  if (number) {
    return new Intl.NumberFormat('vi-VN', {
      style: 'currency',
      currency: 'VND',
    }).format(number);
  }

  return new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
  }).format(0);
};

export const convertFileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () =>
      resolve({
        fileName: file.name,
        base64: reader.result,
      });
    reader.onerror = reject;
  });

export const stringToHslColor = (str, s = 30, l = 80) => {
  let hash = 0;
  for (let i = 0; i < str?.length; i++) {
    hash = str?.charCodeAt(i) + ((hash << 5) - hash);
  }

  const h = hash % 360;
  return 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
};

export const isJsonString = (str) => {
  try {
    return JSON.parse(str);
  } catch (e) {
    return false;
  }
};

export const formatTime = (time, text1, text2, text3) => {
  const date = dayjs(time);
  const now = dayjs();
  if (date.isValid()) {
    const diffInMinutes = now.diff(date, 'minute');
    const diffInHours = now.diff(date, 'hour');
    if (diffInMinutes < 60) {
      return `${diffInMinutes} ${text1}`;
    } else if (diffInHours < 24) {
      return `${diffInHours} ${text2}`;
    } else {
      return date.format(`DD/MM/YYYY ${text3} HH:mm`);
    }
  }
};

export const removeAccents = (str) => {
  const AccentsMap = [
    'aàảãáạăằẳẵắặâầẩẫấậ',
    'AÀẢÃÁẠĂẰẲẴẮẶÂẦẨẪẤẬ',
    'dđ',
    'DĐ',
    'eèẻẽéẹêềểễếệ',
    'EÈẺẼÉẸÊỀỂỄẾỆ',
    'iìỉĩíị',
    'IÌỈĨÍỊ',
    'oòỏõóọôồổỗốộơờởỡớợ',
    'OÒỎÕÓỌÔỒỔỖỐỘƠỜỞỠỚỢ',
    'uùủũúụưừửữứự',
    'UÙỦŨÚỤƯỪỬỮỨỰ',
    'yỳỷỹýỵ',
    'YỲỶỸÝỴ',
  ];
  for (let i = 0; i < AccentsMap.length; i++) {
    const re = new RegExp('[' + AccentsMap[i].substr(1) + ']', 'g');
    const char = AccentsMap[i][0];
    str = str.replace(re, char);
  }
  return str;
};

export const getOperatingSystem = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }

  return 'unknown';
};

export const removeVietnameseTones = (str) => {
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
  str = str.replace(/đ/g, 'd');
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A');
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
  str = str.replace(/Đ/g, 'D');
  // Some system encode vietnamese combining accent as individual utf-8 characters
  // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
  str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ''); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
  str = str.replace(/\u02C6|\u0306|\u031B/g, ''); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
  // Remove extra spaces
  // Bỏ các khoảng trắng liền nhau
  str = str.replace(/ + /g, ' ');
  str = str.replace(/-+/g, '_');
  str = str.trim();
  // Remove punctuations
  // Bỏ dấu câu, kí tự đặc biệt
  str = str.replace(
    /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
    '_',
  );
  return str;
};

export const RenderIf = ({ content1, content2, isTrue }) => {
  return isTrue ? content1 : content2;
};

export const RenderIfWithNull = ({ children, isTrue }) => {
  return isTrue ? children : null;
};

export const convertToHTML = (html, css, js) => {
  return `
  <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
  <html>
  <head>
      <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
      <style>
          ${css}
      </style>
      <script>
          ${js}
      </script>
  </head>
  ${html}
  </html>
  `;
};

export const convertToHTML2 = (content) => {
  const processStyleAttribute = (attributes) => {
    return attributes.replace(/style=["']([^"']*)["']/, (styleMatch, styleValue) => {
      let updatedStyle = styleValue
        .replace(/margin-top\s*:\s*[^;]+;?/i, 'margin-top: 0;')
        .replace(/margin-bottom\s*:\s*[^;]+;?/i, 'margin-bottom: 0;')
        .replace(/margin-left\s*:\s*[^;]+;?/i, 'margin-left: 0;')
        .replace(/margin-right\s*:\s*[^;]+;?/i, 'margin-right: 0;')
        .replace(/margin\s*:\s*[^;]+;?/i, (marginMatch) => {
          const values = marginMatch
            .replace(/margin\s*:\s*/i, '')
            .replace(';', '')
            .split(/\s+/);

          let marginDecl = '';
          if (values.length === 1) {
            marginDecl = `margin: ${values[0]};`;
          } else if (values.length === 2) {
            marginDecl = `margin: ${values[0]} ${values[1]};`;
          } else if (values.length === 3) {
            marginDecl = `margin: ${values[0]} ${values[1]} ${values[2]};`;
          } else if (values.length === 4) {
            marginDecl = `margin: ${values[0]} ${values[1]} ${values[2]} ${values[3]};`;
          }

          return `${marginDecl} margin-top: 0; margin-bottom: 0; margin-left: 0; margin-right: 0;`;
        });

      return `style="${updatedStyle}"`;
    });
  };

  const processTag = (tag) => {
    const regex = new RegExp(`<${tag}([^>]*)>`, 'g');
    return (html) =>
      html.replace(regex, (match, attributes) => {
        if (attributes.includes('style=')) {
          return `<${tag}${processStyleAttribute(attributes)}>`;
        } else {
          return `<${tag}${attributes} style="margin-top: 0; margin-bottom: 0; margin-left: 0; margin-right: 0;">`;
        }
      });
  };

  // Áp dụng xử lý cho cả <p> và <figure>
  let updatedContent = content;
  updatedContent = processTag('p')(updatedContent);
  updatedContent = processTag('figure')(updatedContent);

  return `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html><head><meta http-equiv="Content-Type" content="text/html charset=UTF-8" /></head><body>${updatedContent}</body></html>`;
};

export const sanitizeFileName = (fileName) => {
  // Lấy phần mở rộng của file
  const fileExtension = fileName.includes('.') ? '.' + fileName.split('.').pop() : '';

  // Lấy tên file không bao gồm phần mở rộng
  const fileNameWithoutExtension = fileName.replace(fileExtension, '');

  // Loại bỏ các ký tự đặc biệt, chỉ giữ lại chữ cái, số và dấu gạch dưới
  const sanitizedFileName = fileNameWithoutExtension.replace(/[^a-zA-Z0-9_]+/g, '');

  // Tạo lại tên file đầy đủ với phần mở rộng
  const baseFileName = `${sanitizedFileName}${fileExtension}`;

  return baseFileName;
};

export const compressImage = (file) => {
  return new Promise((resolve, reject) => {
    new Compressor(file, {
      quality: 0.8, // Chất lượng nén
      maxWidth: 1920, // Đặt kích thước tối đa (nếu cần)
      success(result) {
        if (result.size <= 2 * 1024 * 1024) {
          resolve(result); // Trả về file đã nén
        } else {
          reject(new Error('Ảnh vẫn lớn hơn 3MB sau khi nén.'));
        }
      },
      error(err) {
        console.error(err.message);
        reject(err); // Trả về lỗi nếu có
      },
    });
  });
};

export const TRACKING_PARAMS = [
  'zarsrc',
  'rsrc',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'utm_id',
  'fbclid',
  'gclid',
  '_ga',
  '_gl',
];

export const stripTrackingParams = (urlStr) => {
  try {
    if (!urlStr && typeof window !== 'undefined' && window.location) {
      const currentUrl = new URL(window.location.href);
      let changed = false;
      TRACKING_PARAMS.forEach((param) => {
        if (currentUrl.searchParams.has(param)) {
          currentUrl.searchParams.delete(param);
          changed = true;
        }
      });
      if (currentUrl.pathname.includes('%3F') || currentUrl.pathname.includes('?')) {
        const cleanPath = currentUrl.pathname.split('%3F')[0].split('?')[0];
        if (cleanPath !== currentUrl.pathname) {
          currentUrl.pathname = cleanPath;
          changed = true;
        }
      }
      if (changed) {
        const cleanUrl =
          currentUrl.pathname +
          (currentUrl.search ? currentUrl.search : '') +
          (currentUrl.hash ? currentUrl.hash : '');
        window.history.replaceState(window.history.state, document.title, cleanUrl);
      }
      return currentUrl.toString();
    }

    if (typeof urlStr === 'string') {
      const working = urlStr.trim();
      const hasProto = working.startsWith('http://') || working.startsWith('https://');
      const dummyBase = 'https://clean-url-temp.internal';
      const parsed = new URL(hasProto ? working : `${dummyBase}/${working.replace(/^\/+/, '')}`);
      TRACKING_PARAMS.forEach((param) => {
        parsed.searchParams.delete(param);
      });
      if (parsed.pathname.includes('%3F') || parsed.pathname.includes('?')) {
        parsed.pathname = parsed.pathname.split('%3F')[0].split('?')[0];
      }
      if (hasProto) {
        return parsed.toString();
      }
      return (parsed.pathname.replace(/^\/+/, '') + parsed.search + parsed.hash).replace(
        /^clean-url-temp\.internal\/?/,
        '',
      );
    }
  } catch (e) {
    console.error('stripTrackingParams error', e);
  }
  return urlStr;
};

export const stripTrackingSearch = (searchStr) => {
  if (!searchStr) return '';
  try {
    const params = new URLSearchParams(searchStr);
    TRACKING_PARAMS.forEach((p) => params.delete(p));
    const result = params.toString();
    return result ? `?${result}` : '';
  } catch (e) {
    return '';
  }
};

export const extractParamFromUrl = (rawInput, paramName = 'userInviteId') => {
  if (!rawInput) return null;
  const str = String(rawInput).trim();

  // If the scanned string is purely digits and looking for an ID
  if (
    /^\d+$/.test(str) &&
    (paramName === 'userInviteId' || paramName === 'userId' || paramName === 'customerId')
  ) {
    return str;
  }

  // Attempt standard URL parsing
  try {
    const hasProto = str.startsWith('http://') || str.startsWith('https://');
    const parsed = new URL(hasProto ? str : `https://${str}`);

    if (parsed.searchParams.has(paramName)) {
      const val = parsed.searchParams.get(paramName);
      if (val) return val.split('?')[0].split('%3F')[0].trim();
    }

    if (paramName === 'userInviteId' || paramName === 'userId' || paramName === 'customerId') {
      const aliases = ['userInviteId', 'userId', 'id', 'customerId', 'inviteId'];
      for (const alias of aliases) {
        if (parsed.searchParams.has(alias)) {
          const val = parsed.searchParams.get(alias);
          if (val) return val.split('?')[0].split('%3F')[0].trim();
        }
      }
    }

    if (paramName === 'eventId') {
      const aliases = ['eventId', 'idEvent'];
      for (const alias of aliases) {
        if (parsed.searchParams.has(alias)) {
          const val = parsed.searchParams.get(alias);
          if (val) return val.split('?')[0].split('%3F')[0].trim();
        }
      }
    }
  } catch (e) {
    // Fallthrough to regex
  }

  // Regex fallback
  try {
    const regex = new RegExp(`(?:[?&]|%26|%3F)${paramName}=([^&#%]+)`);
    const match = str.match(regex);
    if (match && match[1]) {
      return decodeURIComponent(match[1]).split('?')[0].split('%3F')[0].trim();
    }

    if (paramName === 'userInviteId' || paramName === 'userId' || paramName === 'customerId') {
      const aliasRegex = /(?:[?&]|%26|%3F)(?:userInviteId|userId|id|customerId|inviteId)=([^&#%]+)/;
      const aliasMatch = str.match(aliasRegex);
      if (aliasMatch && aliasMatch[1]) {
        return decodeURIComponent(aliasMatch[1]).split('?')[0].split('%3F')[0].trim();
      }
    }
  } catch (e) {
    console.error('extractParamFromUrl regex error', e);
  }

  return null;
};

